"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashBanner = exports.DashBannerComponent = exports.ROUTES = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var mithril_component_1 = require("../../components/mithril.component");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var page_1 = require("../page");
var dashboard_style_1 = require("./dashboard.style");
exports.ROUTES = {
    POLE_STATUS: function () { return services_1.Services.Route.go(page_1.IkePageName.dashboardPolestatus); },
    POLE_LOADING: function () { return services_1.Services.Route.go(page_1.IkePageName.dashboardPoleloading); },
    MENU: function () { return services_1.Services.Route.go(page_1.IkePageName.dashboardMenu); }
};
var DashBannerComponent = /** @class */ (function (_super) {
    tslib_1.__extends(DashBannerComponent, _super);
    function DashBannerComponent() {
        var _this = _super.call(this) || this;
        _this.name = 'DashBanner';
        return _this;
    }
    Object.defineProperty(DashBannerComponent.prototype, "nodes", {
        get: function () {
            if (!services_1.Services.User.hasUser) {
                services_1.Services.User.logout();
                return null;
            }
            return (0, mithril_1.m)('header', { className: dashboard_style_1.Banner.header.container }, [
                (0, mithril_1.m)('div', { className: dashboard_style_1.Banner.header.row }, [
                    (0, mithril_1.m)('div', { className: dashboard_style_1.Banner.header.section }, [
                        //this.viewMenuIcon, #Future overview page
                        this.viewPoleStatusIcon,
                        this.viewPoleLoadingIcon
                    ])
                ])
            ]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DashBannerComponent.prototype, "viewMenuIcon", {
        get: function () {
            return (0, mithril_1.m)('div', { className: 'button' }, [
                (0, mithril_1.m)('button', { className: dashboard_style_1.MDL.button, onclick: exports.ROUTES.MENU, title: (0, i18n_1.Translate)(i18n_1.T.DASHBOARD) }, [
                    (0, mithril_1.m)('span', { className: dashboard_style_1.Banner.menuButton.span, onclick: exports.ROUTES.MENU, title: (0, i18n_1.Translate)(i18n_1.T.DASHBOARD) }, (0, i18n_1.Translate)(i18n_1.T.DASHBOARD))
                ])
            ]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DashBannerComponent.prototype, "viewPoleStatusIcon", {
        get: function () {
            return (0, mithril_1.m)('div', { className: 'button' }, [
                (0, mithril_1.m)('button', { className: dashboard_style_1.MDL.button, onclick: exports.ROUTES.POLE_STATUS, title: (0, i18n_1.Translate)(i18n_1.T.DASHBOARD_POLE_STATUS) }, [
                    (0, mithril_1.m)('span', { className: (services_1.Services.Route.isPoleStatus() ? dashboard_style_1.Banner.menuButton.spanSelected : dashboard_style_1.Banner.menuButton.span), onclick: exports.ROUTES.POLE_STATUS, title: (0, i18n_1.Translate)(i18n_1.T.DASHBOARD_POLE_STATUS) }, (0, i18n_1.Translate)(i18n_1.T.DASHBOARD_POLE_STATUS))
                ])
            ]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DashBannerComponent.prototype, "viewPoleLoadingIcon", {
        get: function () {
            return (0, mithril_1.m)('div', { className: 'button' }, [
                (0, mithril_1.m)('button', { className: dashboard_style_1.MDL.button, onclick: exports.ROUTES.POLE_LOADING, title: (0, i18n_1.Translate)(i18n_1.T.DASHBOARD_POLE_LOADING) }, [
                    (0, mithril_1.m)('span', { className: (services_1.Services.Route.isPoleLoading() ? dashboard_style_1.Banner.menuButton.spanSelected : dashboard_style_1.Banner.menuButton.span), onclick: exports.ROUTES.POLE_LOADING, title: (0, i18n_1.Translate)(i18n_1.T.DASHBOARD_POLE_LOADING) }, (0, i18n_1.Translate)(i18n_1.T.DASHBOARD_POLE_LOADING))
                ])
            ]);
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.computed
    ], DashBannerComponent.prototype, "nodes", null);
    return DashBannerComponent;
}(mithril_component_1.IMithrilComponent));
exports.DashBannerComponent = DashBannerComponent;
exports.DashBanner = new DashBannerComponent();
//# sourceMappingURL=dashboard.banner.js.map